import { routerPaths } from './tool';
import { RootRouter, routers } from './rootRouter';

const devRouters = [
  ...routers, {
    path: routerPaths.demo,
  }];

export default class RouterDev extends R.Component {
  render() {
    return (
      <RootRouter routers={devRouters} prod={false} />
    );
  }
}
